import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { notify, ConfigService, User } from 'shared';
import moment from 'moment';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss']
})
export class ParametersComponent implements OnInit {
  canGenerate: boolean = false;
  reconstructDate: Date = moment().subtract(1, 'days').toDate();

  constructor(
    public user: User,
    private http: HttpClient,
    private config: ConfigService,
  ) {
  }

  ngOnInit(): void {
    // Check permission for manual reconstruction
    this.canGenerate = this.user.can('generate reconstructed_interventions');
  }

  reconstruct() {
    if (!this.canGenerate) {
      notify('Vous n\'avez pas la permission de lancer une reconstruction manuelle', 'error', 3000);
      return;
    }

    if (!this.reconstructDate) {
      notify('Veuillez sélectionner une date', 'error', 3000);
      return;
    }

    const dateStr = moment(this.reconstructDate).format('YYYY-MM-DD');

    // Show loading notification
    notify('Reconstruction en cours...', 'info', 2000);

    // Call reconstruction API
    this.http.post(this.config.apiVerUrl('/app/reconstructed-interventions/generate'), {
      date: dateStr
    }).subscribe({
      next: (response: any) => {
        notify(`Reconstruction démarrée pour ${dateStr}`, 'success', 5000);
      },
      error: (error) => {
        const errorMsg = error.error?.error || 'Erreur lors de la reconstruction';
        notify(errorMsg, 'error', 5000);
      }
    });
  }
}

